





























































































































































































































































































































































































































































































































































































import _ from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeAgenciaTransfusionalStore from '@/components/Backoffice/Store/BackofficeAgenciaTransfusionalStore'
import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import SolicitacaoComentariosStore from '@/components/SolicitacaoComentarios/Store/SolicitacaoComentariosStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import ContestacaoMedicaStore from '@/components/ContestacaoMedica/Store/ContestacaoMedicaStore'

import { timeout, humanTime, displayColorByStatus, verifyEtapaAgenciaTransfusional, timeoutDefault, groupCollectionByField, maskHour, lembreteColor, getHospitalAreaName } from '@/utils/common'
import { StatusAgenciaTransfusionalEnum, StatusSlaEnum, IRequestMessage, RequestMessage, Loading, LembreteEnum, AgendamentoCirurgia, TipoDocumentoUpload, PendenciaMensagem, TipoMensagemEnum, AgendamentoSolicitacaoItem, User } from '@/types/_'
import { Autorizacao, PendenciaSolicitacao } from '@/types/core'
import moment from 'moment'
import EventBus from '@/plugins/EventBus'

@Component({ filters: { humanTime } })

export default class ViewBackofficeAgenciaTransfusional extends Vue {
  $refs!: {
    cirurgiaDe: any,
  }

  hTime(s: string) {
    return humanTime(s)
  }

  displayDataAgendamento(item: any) {
    if (item.situacao.key === 'Cancelada') return 'Sem reserva'
    if (item.situacaoData.key === 'NovaDataSolicitada') return 'Nova data solicitada'
    if (item.situacaoData.key === 'SemData') return 'Sem data definida'
    if (item.dataAgendamentoVirtual) return 'Data virtual'
    if (item.dataAgendamento) return this.hTime(item.dataAgendamento)
    return 'Sem reserva'
  }

  $user: User;

  loadVisualizar: string = ''
  loadAutorizada: string = ''
  loadContatarPaciente: string = ''
  loadRespondePendencia: string = ''
  loadResolverContestacao: string = ''
  loadAtualizarColeta: string = ''
  loadHistorico: string = ''
  loadComentario: string = ''
  loadRealizarColeta: string = ''
  loadShowModalAnalisarColeta: string = ''
  loadShowModalRealizarTeste: string = ''
  dataValidadeTeste: string = ''
  dataValidadeColeta: string = ''

  loadUpload: boolean = false
  loadMensagem: boolean = false
  modalPendencia: boolean = false
  loadClosePedencia: boolean = false
  loadEncerrarPendencia: boolean = false
  loadConfirmarEncerrarPendencia: boolean = false
  modalConfirmarEncerrarPendencia: boolean = false
  loadCloseConfiramrEncerrarPendencia: boolean = false
  loadVisualizarDrillDown: boolean = false
  readyState: boolean = false
  loadAnalisarColeta: boolean = false
  loadAnalisarTeste: boolean = false

  mensagem: string = ''

  inputFiles: any[] = []

  expand: boolean = false
  headers: any[] = [
    { text: '', value: '', sortable: false, active: true },
    { text: 'Paciente', value: 'pacienteNome', sortable: false, active: true },
    { text: 'Médico', value: 'medicoNome', sortable: false, active: true },
    { text: 'Reserva', value: 'numeroAgendamento', sortable: false, active: true },
    { text: 'Item particular', value: 'temItemParticular', sortable: false, active: true },
    { text: 'Caráter', value: 'carater', sortable: false, active: true },
    { text: 'Situação da coleta', value: 'statusAgenciaTransfusional', sortable: false, active: true },
    { text: 'Ações', value: 'acoes', sortable: false, active: true, width: '157.41px' },
    { text: 'Data da cirurgia', value: 'dataAgendamento', sortable: false, active: true },
    { text: '', value: '', sortable: false, active: true },
  ]

  autorizacao: Autorizacao.IAutorizacao = new Autorizacao.Autorizacao()
  pendenciaSolicitacao: PendenciaSolicitacao.IPendenciaSolicitacao = new PendenciaSolicitacao.PendenciaSolicitacao()
  getRequestMessage: IRequestMessage = new RequestMessage()
  areaDoHospital: any = getHospitalAreaName()

  loadingReq: Loading = {
    status: false,
    text: '',
  }

  displayPendencia: any = {
    nomePaciente: '',
    nomeMedico: '',
  }

  coletaRealizadaRules: any = {
    dataColetaRules: [v => !!v || 'O campo é obrigatório.'],
  }

  get showModalColeta() {
    return this.getBackofficeAgenciaTransfusionalStore.modal.coleta
  }

  set showModalColeta(value: boolean) {
    this.getBackofficeAgenciaTransfusionalStore.setShowModalColeta(value)
  }

  get showModalTeste() {
    return this.getBackofficeAgenciaTransfusionalStore.modal.teste
  }

  set showModalTeste(value: boolean) {
    this.getBackofficeAgenciaTransfusionalStore.setShowModalTeste(value)
  }

  get coletaRealizada() {
    return this.getBackofficeAgenciaTransfusionalStore.coletaRealizada
  }

  set coletaRealizada(value: boolean) {
    this.getBackofficeAgenciaTransfusionalStore.setColetaRealizada(value)
  }

  get loadingRealizarColeta() {
    return this.loadRealizarColeta
  }

  set loadingRealizarColeta(value: string) {
    this.loadRealizarColeta = value
  }

  get loadingAnalisarColeta() {
    return this.loadAnalisarColeta
  }

  set loadingAnalisarColeta(value: boolean) {
    this.loadAnalisarColeta = value
  }

  get loadingShowModalAnalisarColeta() {
    return this.loadShowModalAnalisarColeta
  }

  set loadingShowModalAnalisarColeta(value: string) {
    this.loadShowModalAnalisarColeta = value
  }

  get loadingShowModalRealizarTeste() {
    return this.loadShowModalRealizarTeste
  }

  set loadingShowModalRealizarTeste(value: string) {
    this.loadShowModalRealizarTeste = value
  }

  get loadingRealizarTeste() {
    return this.loadAnalisarTeste
  }

  set loadingRealizarTeste(value: boolean) {
    this.loadAnalisarTeste = value
  }

  get loadingComentario() {
    return this.loadComentario
  }

  set loadingComentario(value: string) {
    this.loadComentario = value
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: string) {
    this.loadHistorico = value
  }

  get loadingAtualizarColeta() {
    return this.loadAtualizarColeta
  }

  set loadingAtualizarColeta(value: string) {
    this.loadAtualizarColeta = value
  }

  get loadingCloseConfirmarEncerrarPendencia() {
    return this.loadCloseConfiramrEncerrarPendencia
  }

  set loadingCloseConfirmarEncerrarPendencia(value: boolean) {
    this.loadCloseConfiramrEncerrarPendencia = value
  }

  get loadingConfirmarEncerrarPendencia() {
    return this.loadConfirmarEncerrarPendencia
  }

  set loadingConfirmarEncerrarPendencia(value: boolean) {
    this.loadConfirmarEncerrarPendencia = value
  }

  get showModalConfirmarEncerrarPendencia() {
    return this.modalConfirmarEncerrarPendencia
  }

  set showModalConfirmarEncerrarPendencia(value: boolean) {
    this.modalConfirmarEncerrarPendencia = value
  }

  get loadingEncerrarPendencia() {
    return this.loadEncerrarPendencia
  }

  set loadingEncerrarPendencia(value: boolean) {
    this.loadEncerrarPendencia = value
  }

  get loadingResolverContestacao() {
    return this.loadResolverContestacao
  }

  set loadingResolverContestacao(value: string) {
    this.loadResolverContestacao = value
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  get loadingRespondePendencia() {
    return this.loadRespondePendencia
  }

  set loadingRespondePendencia(value: string) {
    this.loadRespondePendencia = value
  }

  get loadingUpload() {
    return this.loadUpload
  }

  set loadingUpload(val: boolean) {
    this.loadUpload = val
  }

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(val: boolean) {
    this.loadMensagem = val
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(texto: string) {
    this.mensagem = texto
  }

  get getDisplayPendencia() {
    return this.displayPendencia
  }

  set getDisplayPendencia(value: any) {
    this.displayPendencia = value
  }

  get loadingClosePendencia() {
    return this.loadClosePedencia
  }

  set loadingClosePendencia(value: boolean) {
    this.loadClosePedencia = value
  }

  get showModalPendencia() {
    return this.modalPendencia
  }

  set showModalPendencia(value: boolean) {
    this.modalPendencia = value
  }

  get loadingAutorizada() {
    return this.loadAutorizada
  }

  set loadingAutorizada(val: string) {
    this.loadAutorizada = val
  }

  get loadingVisualizar() {
    return this.loadVisualizar
  }

  set loadingVisualizar(val: string) {
    this.loadVisualizar = val
  }

  get loadingVisualizarDrillDown() {
    return this.loadVisualizarDrillDown
  }

  set loadingVisualizarDrillDown(val: boolean) {
    this.loadVisualizarDrillDown = val
  }

  get loadingContatarPaciente() {
    return this.loadContatarPaciente
  }

  set loadingContatarPaciente(value: string) {
    this.loadContatarPaciente = value
  }

  get loadingRequest() {
    return this.loadingReq
  }

  set loadingRequest(value: Loading) {
    this.loadingReq = value
  }

  modDe: boolean = false

  get de() {
    return this.getBackofficeAgenciaTransfusionalStore.deFiltro
  }

  set de(value: Date | string | null) {
    this.getBackofficeAgenciaTransfusionalStore.setDeFiltro(value)
  }

  get formattedDe() {
    return this.formatDateRange(this.de)
  }

  get modalDe() {
    return this.modDe
  }

  set modalDe(value: boolean) {
    this.modDe = value
  }

  formatDateRange(date: Date | string | null) {
    if (!date) return null
    const [year, month, day] = date.toString().split('-')
    return `${day}/${month}/${year}`
  }

  resetModalDe() {
    this.de = null
    this.modalDe = false
  }

  minDate(date: string) {
    if (!date) return null
    const min = moment(date).add(1, 'day').format('YYYY-MM-DD')
    return min
  }

  maxDate(date: string) {
    if (!date) return null
    const max = moment(date).add(1, 'year').format('YYYY-MM-DD')
    return max
  }

  clearDate(field: string) {
    if (field === 'de') {
      this.de = null
    }
  }

  columnSelectionMenu: boolean = false

  hasActiveHeader(value: string) {
    if (value === '') return true
    return this.headers.find(header => header.value === value).active
  }

  getTableHeaders() {
    const headers = localStorage.getItem('backoffice-agencia-transfusional-table-headers')
    this.headers = headers ? JSON.parse(headers) : this.headers
  }

  saveHeaders() {
    (localStorage as any).setItem('backoffice-agencia-transfusional-table-headers', JSON.stringify(this.headers, null, 2))
  }

  async init() {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    this.getBackofficeAgenciaTransfusionalStore.clearSolicitacoes()
    this.getBackofficeAgenciaTransfusionalStore.clearFiltro()
    this.getBackofficeAgenciaTransfusionalStore.setFilterOn(false)
    this.getBackofficeAgenciaTransfusionalStore.clearSituacoes()
    this.getBackofficeAgenciaTransfusionalStore.clearStatusAT()
    this.getBackofficeAgenciaTransfusionalStore.setStatusAT(StatusAgenciaTransfusionalEnum.ContatoPendente)
    // this.getBackofficeAgenciaTransfusionalStore.setSituacoes(SituacaoEnum.EmCotacao)

    this.de = moment(new Date()).subtract(3, 'months').format('YYYY-MM-DD')

    this.getBackofficeAgenciaTransfusionalStore.setEtapa('agenciaTransfusional')
    await this.getBackofficeAgenciaTransfusionalStore.loadAgendamentosMedicoSearch()
    this.readyState = true
    this.getTableHeaders()
    this.clearLoadingRequest()
  }

  displayReserva(item: any) {
    if (item.situacaoData.key === 'SemData') return 'Sem data definida'
    return item.numeroAgendamento || 'Sem reserva'
  }

  setLoadingRequest(status: boolean, text: string) {
    this.loadingRequest = { status, text }
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeAgenciaTransfusionalStore() {
    return getModule(BackofficeAgenciaTransfusionalStore, this.$store)
  }

  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get solicitacoes() {
    return this.getBackofficeAgenciaTransfusionalStore.solicitacoes
  }

  get drawer() {
    return this.getBackofficeAgenciaTransfusionalStore.filterDrawer
  }

  set drawer(value: boolean) {
    this.getBackofficeAgenciaTransfusionalStore.setFilterDrawer(value)
  }

  get etapa() {
    return this.getBackofficeAgenciaTransfusionalStore.statusAT
  }

  set etapa(value: any) {
    this.getBackofficeAgenciaTransfusionalStore.setStatusAT(value.key)
  }

  get etapas() {
    return [
      { key: StatusAgenciaTransfusionalEnum.ContatoPendente, display: 'Contato pendente', quantidade: this.getContatoPendenteTotal },
      { key: StatusAgenciaTransfusionalEnum.AguardandoPaciente, display: 'Aguardando paciente', quantidade: this.getAguardandoPacienteTotal },
      { key: StatusAgenciaTransfusionalEnum.ColetaRealizada, display: 'Coleta realizada', quantidade: this.getColetaRealizadaTotal },
      { key: StatusAgenciaTransfusionalEnum.TestePendente, display: 'Teste pendente', quantidade: this.getTestePendenteTotal },
      { key: StatusAgenciaTransfusionalEnum.ReservaConfirmada, display: 'Reserva confirmada', quantidade: this.getReservaConfirmadaTotal },
    ]
  }

  get getAllEtapas() {
    return this.etapa.length === this.etapas.length
  }

  get getSomeEtapas() {
    return this.etapa.length > 0 && !this.getAllEtapas
  }

  get icon() {
    if (this.getAllEtapas) return 'mdi-checkbox-marked'
    if (this.getSomeEtapas) return 'mdi-minus-box'
    return 'mdi-checkbox-blank-outline'
  }

  get getMensagens() {
    return this.getPendenciaStore.pendencia.mensagens
  }

  groupByDate(value: any) {
    return groupCollectionByField(value)
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  get todosOsStatus() {
    return this.getBackofficeAgenciaTransfusionalStore.todosOsStatus
  }

  set todosOsStatus(value: boolean) {
    this.getBackofficeAgenciaTransfusionalStore.setTodosOsStatus(value)
  }

  get todosOsStatusDaArea() {
    return this.getBackofficeAgenciaTransfusionalStore.todosOsStatusDaArea
  }

  set todosOsStatusDaArea(value: boolean) {
    this.getBackofficeAgenciaTransfusionalStore.setTodosOsStatusDaArea(value)
  }

  get iconTodosOsStatus() {
    return this.todosOsStatus ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
  }

  get iconTodosOsStatusDaArea() {
    return this.todosOsStatusDaArea ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
  }

  selectAllFromHospital() {
    this.$nextTick(() => {
      this.todosOsStatus = !this.todosOsStatus
    })
  }

  selectAllFromArea() {
    this.$nextTick(() => {
      this.todosOsStatusDaArea = !this.todosOsStatusDaArea
    })
  }

  selectSituacao(item: any) {
    if (this.todosOsStatus || this.todosOsStatusDaArea) {
      this.todosOsStatus = false
      this.todosOsStatusDaArea = false
      this.getBackofficeAgenciaTransfusionalStore.clearSituacoes()
    }
    this.etapa = item
  }

  async filterSituacao() {
    if (!this.de) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Preencha o campo de Data de início do período', icon: 'warning', color: '#C62828' })
      return
    }
    this.getBackofficeAgenciaTransfusionalStore.clearPagePagination()
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    await this.getBackofficeAgenciaTransfusionalStore.loadAgendamentosMedicoSearch()
    this.clearLoadingRequest()
  }

  get getContatoPendenteTotal() {
    const { statusAgenciasTransfusionaisCounter } = this.getBackofficeAgenciaTransfusionalStore
    if (statusAgenciasTransfusionaisCounter.some(c => c.key === 'ContatoPendente')
      && statusAgenciasTransfusionaisCounter.filter(c => c.key === 'ContatoPendente').length > 0) {
      return statusAgenciasTransfusionaisCounter.filter(c => c.key === 'ContatoPendente')[0].quantidade
    }
    return 0
  }

  get getAguardandoPacienteTotal() {
    const { statusAgenciasTransfusionaisCounter } = this.getBackofficeAgenciaTransfusionalStore
    if (statusAgenciasTransfusionaisCounter.some(c => c.key === 'AguardandoPaciente')
      && statusAgenciasTransfusionaisCounter.filter(c => c.key === 'AguardandoPaciente').length > 0) {
      return statusAgenciasTransfusionaisCounter.filter(c => c.key === 'AguardandoPaciente')[0].quantidade
    }
    return 0
  }

  get getColetaRealizadaTotal() {
    const { statusAgenciasTransfusionaisCounter } = this.getBackofficeAgenciaTransfusionalStore
    if (statusAgenciasTransfusionaisCounter.some(c => c.key === 'ColetaRealizada')
      && statusAgenciasTransfusionaisCounter.filter(c => c.key === 'ColetaRealizada').length > 0) {
      return statusAgenciasTransfusionaisCounter.filter(c => c.key === 'ColetaRealizada')[0].quantidade
    }
    return 0
  }

  get getTestePendenteTotal() {
    const { statusAgenciasTransfusionaisCounter } = this.getBackofficeAgenciaTransfusionalStore
    if (statusAgenciasTransfusionaisCounter.some(c => c.key === 'TestePendente')
      && statusAgenciasTransfusionaisCounter.filter(c => c.key === 'TestePendente').length > 0) {
      return statusAgenciasTransfusionaisCounter.filter(c => c.key === 'TestePendente')[0].quantidade
    }
    return 0
  }

  get getReservaConfirmadaTotal() {
    const { statusAgenciasTransfusionaisCounter } = this.getBackofficeAgenciaTransfusionalStore
    if (statusAgenciasTransfusionaisCounter.some(c => c.key === 'ReservaConfirmada')
      && statusAgenciasTransfusionaisCounter.filter(c => c.key === 'ReservaConfirmada').length > 0) {
      return statusAgenciasTransfusionaisCounter.filter(c => c.key === 'ReservaConfirmada')[0].quantidade
    }
    return 0
  }


  get getTotal() {
    return this.getBackofficeAgenciaTransfusionalStore.totalSolicitacoes || 0
  }

  async showModalVisualizar(agendamentoCirurgia: AgendamentoCirurgia) {
    this.loadingVisualizarDrillDown = true

    this.getBackofficeGlobalStore.setBackofficeArea('agenciaTransfusional')
    this.getBackofficeGlobalStore.setSolicitacaoId(agendamentoCirurgia.id)
    this.getBackofficeGlobalStore.setModal({ name: 'visualizacao', value: true })

    this.ga('backoffice-agencia-transfusional', 'visualizar-agencia-transfusional')
    this.loadingVisualizarDrillDown = false
  }

  verifyEtapa(item: any) {
    return verifyEtapaAgenciaTransfusional(item)
  }

  showAdvancedFilters() {
    this.drawer = !this.drawer
  }

  getColor(status: string) {
    switch (status) {
      case 'Apto':
        return { color: 'green darken-2', icon: 'thumb_up', tooltip: 'Paciente apto para cirurgia' }
      case 'AptoComAtencao':
        return { color: 'yellow darken-3', icon: 'thumb_up', tooltip: 'Verificar alterações feitas pelo anestesista' }
      case 'NaoApto':
        return { color: 'red darken-3', icon: 'thumb_down', tooltip: 'Paciente não está apto para cirurgia' }
      default:
        return { color: 'orange darken-4', icon: 'schedule', tooltip: 'Avaliação pré-anestésica pendente' }
    }
  }

  getTableRowClasses(data: AgendamentoSolicitacaoItem) {
    const classes: string[] = []

    if (data.jaPassouPorEsteStatus) {
      classes.push('backoffice-list-table-row__japassouporessestatus')
    }

    if (data.carater.key === 'Urgencia') {
      classes.push('backoffice-list-table-row__urgencia')
    }

    if (data.auditada && this.$user.profile.roles.includes('auditoria') && ['BackofficeAutorizacao', 'BackofficeAgendamento'].includes(this.$route.name!)) {
      classes.push('backoffice-list-table-row__auditada')
    }

    return classes
  }

  async clearAdvancedFilters() {
    this.getBackofficeAgenciaTransfusionalStore.clearFiltro()
    this.getBackofficeAgenciaTransfusionalStore.setFilterOn(false)
    this.drawer = false
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)

    this.de = moment(new Date()).subtract(3, 'months').format('YYYY-MM-DD')
    this.clearLoadingRequest()
  }

  displayCorEtapa(value: string) {
    return displayColorByStatus(value)
  }

  slaColor(statusSla: StatusSlaEnum) {
    switch (statusSla) {
      case StatusSlaEnum.Normal:
        return 'green'

      case StatusSlaEnum.Alerta:
        return 'yellow'

      case StatusSlaEnum.Critico:
        return 'red'

      default:
        return ''
    }
  }

  async showHistory(solicitacaoId: string) {
    this.loadingHistorico = solicitacaoId
    await this.getHistoricoSolicitacaoStore.getHistoricoSolicitacao(solicitacaoId)
    this.loadingHistorico = ''
  }

  /**
   * ========== COMENTÁRIO E LEMBRETE ==========
   */

  get getComentariosStore() {
    return getModule(SolicitacaoComentariosStore, this.$store)
  }

  async showComentario(solicitacaoId: string) {
    this.loadingComentario = solicitacaoId
    await this.getComentariosStore.getComentariosBySolicitacaoId(solicitacaoId)
    this.getComentariosStore.setShowModalComentario(true)
    this.loadingComentario = ''
  }

  lembreteColorDisplay(lembrete: LembreteEnum) {
    return lembreteColor(lembrete)
  }

  /**
   * ========== PAGINAÇÃO ==========
   */

  get getPagina() {
    return this.getBackofficeAgenciaTransfusionalStore.pagina
  }

  set getPagina(value: number) {
    this.getBackofficeAgenciaTransfusionalStore.setPagina(value)
  }

  get getQtdPorPagina() {
    return this.getBackofficeAgenciaTransfusionalStore.qtdPorPagina
  }

  set getQtdPorPagina(value: number) {
    this.getBackofficeAgenciaTransfusionalStore.setQtdPorPagina(value)
  }

  get getTotalSolicitacoes() {
    return this.getBackofficeAgenciaTransfusionalStore.totalSolicitacoes
  }

  get agendamentoLength() {
    return Math.ceil(this.getTotalSolicitacoes / this.getQtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  async getResults(pagina: number) {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    this.getPagina = pagina
    await this.getBackofficeAgenciaTransfusionalStore.loadAgendamentosMedicoSearch()
    this.clearLoadingRequest()
  }

  async mounted() {
    await this.init()
    EventBus.$on('setLembrete', value => this.getBackofficeAgenciaTransfusionalStore.setLembreteStatus(value))
  }

  /**
   * ============ MODAIS E BOTÕES ==============
   */

  get getPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getContestacaoMedicaStore() {
    return getModule(ContestacaoMedicaStore, this.$store)
  }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  async openFlowModal(solicitacaoId: string) {
    const response = await this.getBackofficeGlobalStore.getSolicitacaoById(solicitacaoId)
    if (response.success) {
      switch (this.getBackofficeGlobalStore.solicitacao.situacao.key) {
        case 'EmCotacao':
          this.getBackofficeGlobalStore.setModal({ name: 'suprimentosAguardandoCotacao', value: true })
          this.ga('backoffice-suprimentos', 'aguardando-cotacao')
          break

        default:
          EventBus.$emit('setSnackbar', { show: true, text: 'Pendência encerrada com sucesso.', icon: 'done', color: '#2E7D32' })
          this.ga('backoffice-agencia-transfusional', 'pendencia encerrada')
          this.getBackofficeGlobalStore.setBackofficeArea('agenciaTransfusional')
          this.getBackofficeGlobalStore.setSolicitacaoId(solicitacaoId)
          this.getBackofficeGlobalStore.setModal({ name: 'visualizacao', value: true })
          break
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }
  }

  async realizarAvaliacao(agendamentoCirurgia: AgendamentoCirurgia) {
    //
  }

  /** Pendência */
  async showModalRespondePendencia(agendamentoCirurgia: AgendamentoCirurgia) {
    const solicitacaoId = agendamentoCirurgia.id
    this.getBackofficeGlobalStore.setHospitalId(agendamentoCirurgia.hospitalId)
    this.loadingRespondePendencia = solicitacaoId
    let response = await this.autorizacao.bloquearSolicitacao(solicitacaoId)
    if (response.success) {
      response = await this.getPendenciaStore.getPendencias(solicitacaoId)
      if (response.success) {
        this.getDisplayPendencia = {
          nomePaciente: agendamentoCirurgia.pacienteNome,
          nomeMedico: agendamentoCirurgia.medicoNome,
        }
        this.showModalPendencia = true
        this.getBackofficeGlobalStore.setSolicitacaoId(solicitacaoId)
      } else {
        this.getBackofficeAgenciaTransfusionalStore.deleteSolicitacao(solicitacaoId)
        await this.openFlowModal(solicitacaoId)
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'done', color: '#2E7D32' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }
    this.loadingRespondePendencia = ''
    this.ga('backoffice-agencia-transfusional', 'responder-pendencia-aguardando-cotacao')
  }


  async encerrarPendencia() {
    this.loadingEncerrarPendencia = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const response = await this.pendenciaSolicitacao.encerrarPendencia(solicitacaoId)

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Pendência encerrada com sucesso.', icon: 'done', color: '#2E7D32' })
      const item: AgendamentoSolicitacaoItem = this.getBackofficeAgenciaTransfusionalStore.solicitacoes.filter(c => c.id === solicitacaoId)[0]
      this.getBackofficeAgenciaTransfusionalStore.deleteSolicitacao(solicitacaoId)
      await this.openFlowModal(solicitacaoId)
      await this.closeModalPendencia()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao encerrar a pendência.', icon: 'warning', color: '#C62828' })
    }
  }

  async sendMensagem() {
    this.loadingMensagem = true
    await timeoutDefault()

    const time = moment().format('YYYY-MM-DDTHH:mm')
    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital: true,
      id: '',
      dataEnvio: time,
      tipoMensagem: TipoMensagemEnum.Texto,
      texto: this.getMensagem,
    }

    await this.getPendenciaStore.enviarMensagem(pendenciaMensagem)
    this.getBackofficeAgenciaTransfusionalStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    this.getMensagem = ''
    this.loadingMensagem = false
  }

  async inputFileAguardandoCotacao(newFile, oldFile) {
    this.loadingUpload = true
    if (newFile.identifier) {
      return
    }

    const form = new FormData()
    form.append('laudos', newFile.file)
    const time = moment().format('YYYY-MM-DDTHH:mm:ss')

    const param: any = {
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      tipoDocumento: TipoDocumentoUpload.PendenciaHospital,
      formData: form,
    }

    let response = await this.getPendenciaStore.uploadDocumento(param)
    if (response.success) {
      const result = response.data[0]
      const documentoId = result.id
      const { url } = result
      const { nomeArquivo } = result

      const pendenciaMensagem: PendenciaMensagem = {
        mensagemHospital: true,
        id: documentoId,
        dataEnvio: time,
        tipoMensagem: TipoMensagemEnum.Documento,
        texto: '',
        documentoId,
        url,
        nomeArquivo,
      }

      response = await this.getPendenciaStore.enviarMensagem(pendenciaMensagem)
      if (response.success) {
        this.getBackofficeAgenciaTransfusionalStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
      }
    }

    this.loadingUpload = false
  }

  async confirmarEncerrarPendencia() {
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    this.loadingConfirmarEncerrarPendencia = true
    const response = await this.pendenciaSolicitacao.encerrarPendencia(solicitacaoId)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Pendência encerrada com sucesso.', icon: 'done', color: '#2E7D32' })
      await this.openFlowModal(solicitacaoId)
      this.getBackofficeAgenciaTransfusionalStore.deleteSolicitacao(solicitacaoId)
      this.closeModalPendencia()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao encerrar a pendência.', icon: 'warning', color: '#C62828' })
    }

    this.loadingConfirmarEncerrarPendencia = false
  }

  async confirmarEncerrarPendenciaCloseModal() {
    this.loadingClosePendencia = true
    await timeoutDefault()
    this.showModalConfirmarEncerrarPendencia = true
    this.loadingClosePendencia = false
  }

  async closeEncerrarPendenciaCloseModal() {
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    this.loadingCloseConfirmarEncerrarPendencia = true
    await this.autorizacao.desbloquearSolicitacao(solicitacaoId)
    this.closeModalPendencia()
  }

  async closeModalPendencia() {
    await timeoutDefault()
    this.showModalPendencia = false
    this.showModalConfirmarEncerrarPendencia = false

    this.loadingCloseConfirmarEncerrarPendencia = false
    this.loadingEncerrarPendencia = false
    this.getDisplayPendencia = {
      nomePaciente: '',
      nomeMedico: '',
    }
    this.getPendenciaStore.clearPendencia()
  }

  closeModalColeta() {
    this.getBackofficeAgenciaTransfusionalStore.clearColetaRealizada()
    this.getBackofficeAgenciaTransfusionalStore.clearColetaId()
    this.dataValidadeColeta = ''
    this.showModalColeta = false
  }

  closeModalTeste() {
    this.getBackofficeAgenciaTransfusionalStore.clearColetaId()
    this.dataValidadeTeste = ''
    this.showModalTeste = false
  }

  async contatarPaciente(solicitacaoId: AgendamentoSolicitacaoItem) {
    this.loadingContatarPaciente = solicitacaoId.id
    const params: any = {
      solicitacaoId: solicitacaoId.id,
      status: 'AguardandoPaciente',
    }
    const response = await this.getBackofficeAgenciaTransfusionalStore.backOfficeAgenciaTransfusionalContataPaciente(params)
    if (!response || !response.success) EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível contatar o paciente.', icon: 'warning', color: '#C62828' })
    this.loadingContatarPaciente = ''
  }

  async realizarColeta(solicitacaoId: AgendamentoSolicitacaoItem) {
    this.loadingRealizarColeta = solicitacaoId.id
    const params: any = {
      solicitacaoId: solicitacaoId.id,
      status: 'ColetaRealizada',
    }
    const response = await this.getBackofficeAgenciaTransfusionalStore.backOfficeAgenciaTransfusionalRealizaColeta(params)
    if (!response || !response.success) EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível atualizar o status da coleta.', icon: 'warning', color: '#C62828' })
    this.loadingRealizarColeta = ''
  }

  async analisarColeta() {
    this.loadingAnalisarColeta = true
    if (this.coletaRealizada === true) {
      const params: any = {
        solicitacaoId: this.getBackofficeAgenciaTransfusionalStore.coletaId,
        status: 'TestePendente',
        realizaTesteExterno: this.coletaRealizada,
      }
      const response = await this.getBackofficeAgenciaTransfusionalStore.backOfficeAgenciaTransfusionalAnalisaColeta(params)
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Teste realizado com sucesso!', icon: 'done', color: '#2E7D32' })
        this.closeModalColeta()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível atualizar o status do Teste.', icon: 'warning', color: '#C62828' })
      }
      this.loadingAnalisarColeta = false
    } else {
      const params: any = {
        solicitacaoId: this.getBackofficeAgenciaTransfusionalStore.coletaId,
        status: 'ReservaConfirmada',
        dataValidade: this.dataValidadeColeta,
        realizaTesteExterno: this.coletaRealizada,
      }
      const response = await this.getBackofficeAgenciaTransfusionalStore.backOfficeAgenciaTransfusionalAnalisaColeta(params)
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Teste realizado com sucesso!', icon: 'done', color: '#2E7D32' })
        this.closeModalColeta()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível atualizar o status do Teste.', icon: 'warning', color: '#C62828' })
      }
      this.loadingAnalisarColeta = false
    }
  }

  async showModalAnalisarColeta(solicitacaoId: AgendamentoSolicitacaoItem) {
    this.loadingShowModalAnalisarColeta = solicitacaoId.id
    await timeout(500)
    this.getBackofficeAgenciaTransfusionalStore.setColetaId(solicitacaoId.id)
    this.showModalColeta = true
    this.loadingShowModalAnalisarColeta = ''
  }

  async showModalRealizarTeste(solicitacaoId: AgendamentoSolicitacaoItem) {
    this.loadingShowModalRealizarTeste = solicitacaoId.id
    await timeout(500)
    this.getBackofficeAgenciaTransfusionalStore.setTesteId(solicitacaoId.id)
    this.showModalTeste = true
    this.loadingShowModalRealizarTeste = ''
  }

  async realizarTeste() {
    this.loadingRealizarTeste = true

    const params: any = {
      solicitacaoId: this.getBackofficeAgenciaTransfusionalStore.testeId,
      dataValidade: this.dataValidadeTeste,
      status: 'ReservaConfirmada',
    }
    const response = await this.getBackofficeAgenciaTransfusionalStore.backOfficeAgenciaTransfusionalRealizaTeste(params)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Teste realizado com sucesso!', icon: 'done', color: '#2E7D32' })
      this.closeModalTeste()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível atualizar o status do Teste.', icon: 'warning', color: '#C62828' })
    }
    this.loadingRealizarTeste = false
  }

  loadAllSolicitacoes: boolean = false

  get loadingAllSolicitacoes() { return this.loadAllSolicitacoes }
  set loadingAllSolicitacoes(value: boolean) { this.loadAllSolicitacoes = value }

  async getAllBackofficeSolicitacoes() {
    this.loadingAllSolicitacoes = true
    const response = await this.getBackofficeAgenciaTransfusionalStore.loadAgendamentosMedicoSearch()
    if (!response.success) EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao buscar as solicitações', icon: 'warning', color: '#C62828' })
    this.loadingAllSolicitacoes = false
  }

  beforeDestroy() {
    this.getBackofficeAgenciaTransfusionalStore.clearFiltro()
    this.getBackofficeAgenciaTransfusionalStore.setFilterOn(false)
    this.getBackofficeAgenciaTransfusionalStore.setTodosOsStatus(false)
    this.getBackofficeAgenciaTransfusionalStore.setTodosOsStatusDaArea(false)
    this.getBackofficeAgenciaTransfusionalStore.resetStatusAT()
    this.getBackofficeGlobalStore.setBackofficeArea('')
  }

  created() {
    window.addEventListener('keydown', this.keyboardShortCuts)
  }

  destroyed() {
    window.removeEventListener('keydown', this.keyboardShortCuts)
  }

  keyboardShortCuts(event: KeyboardEvent) {
    if (event.ctrlKey && event.code === 'Space' && !!this.showAdvancedFilters) this.showAdvancedFilters()
    if (event.ctrlKey && event.altKey && event.code === 'Space' && !!this.clearAdvancedFilters) this.clearAdvancedFilters()
  }
}
